export default [
    { // 登录页面
        path: '/index/login',
        name: 'Login',
        component: () => import('@/views/login/Login.vue'),
        meta: {
            showTab: false
        }
    },
    {  // 注册页面
        path: '/index/register',
        name: 'Register',
        component: () => import('@/views/login/Register.vue'),
        meta: {
            showTab: false
        }
    },
    { // 忘记密码页面
        path: '/index/forgetPassword',
        name: 'ForgetPassword',
        component: () => import('@/views/login/ForgetPassword.vue'),
        meta: {
            showTab: false
        }
    },
    { // 手机登录页面
        path: '/index/loginPhone',
        name: 'loginPhone',
        component: () => import('@/views/login/loginPhone.vue'),
        meta: {
            showTab: false
        }
    }

]

